import { EntityService } from "src/app/core/services/entity.service";
import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LiftModuleDetail } from "../models/lift-module-detail.model";
import { LiftModuleList } from "../models/lift-module-list.model";
import { LiftModuleUpdate } from "../models/lift-module-update.model";
import { LiftModuleCreate } from "../models/lift-module-create.model";

@Injectable({
  providedIn: 'root'
})
export class LiftModuleService extends EntityService<LiftModuleDetail, LiftModuleList, LiftModuleUpdate, LiftModuleCreate> {
  constructor(
    httpClient: HttpClient,
    @Inject('BASE_URL') baseUrl: string) {
    super(httpClient, baseUrl + 'api/liftModule');
  }

  delete(id: number) {
    const url = this.apiUrl + '/' + String(id);
    return this.httpClient.delete(url);
  }
}
